import { useEffect, useState } from "react";
import { getOrders, updateOrder } from "../../../services/adminOrderApi";
import "./orders.css";

const STATUS_FILTER = ["all", "pending", "approved", "completed", "rejected"];

export default function AdminOrderList() {
  const [orders,       setOrders]       = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await getOrders();
      setOrders(res.data.orders || []);
    } catch (err) { console.error(err); alert("Failed to load orders"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchOrders(); }, []);

  const handleUpdate = async (id, status) => {
    try {
      await updateOrder(id, { status });
      fetchOrders();
    } catch { alert("Failed to update order"); }
  };

  /* ── counts ── */
  const pending   = orders.filter(o => o.status === "pending").length;
  const approved  = orders.filter(o => o.status === "approved").length;
  const completed = orders.filter(o => o.status === "completed").length;

  const filtered = statusFilter === "all"
    ? orders
    : orders.filter(o => o.status === statusFilter);

  return (
    <div className="ord-page">

      {/* ══ HERO ══ */}
      <div className="ord-hero">
        <div className="ord-hero-left">
          <div className="ord-hero-icon">🛒</div>
          <div>
            <h2 className="ord-hero-title">Teacher Orders</h2>
            <p className="ord-hero-sub">Manage inventory requests from teachers</p>
          </div>
        </div>
        <div className="ord-hero-right">
          <span className="ord-hero-stat">⏳ {pending} pending</span>
          <span className="ord-hero-stat">✅ {completed} completed</span>
        </div>
      </div>

      {/* ══ FILTER ══ */}
      <div className="ord-filter">
        <span className="ord-filter-label">Status</span>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          {STATUS_FILTER.map(s => (
            <option key={s} value={s}>
              {s === "all" ? "All Orders" : s.charAt(0).toUpperCase() + s.slice(1)}
            </option>
          ))}
        </select>
      </div>

      {/* ══ CARDS GRID ══ */}
      {loading ? (
        <div className="ord-empty">
          <div className="ord-empty-icon">⏳</div>
          <strong>Loading orders…</strong>
        </div>
      ) : filtered.length === 0 ? (
        <div className="ord-empty">
          <div className="ord-empty-icon">📭</div>
          <strong>No orders found</strong>
          <p>No {statusFilter !== "all" ? statusFilter : ""} orders at the moment</p>
        </div>
      ) : (
        <div className="ord-grid">
          {filtered.map(o => (
            <div key={o.id} className="ord-card">

              {/* HEAD */}
              <div className="ord-card-head">
                <div>
                  <div className="ord-teacher">👨‍🏫 {o.teacher_name || o.teacher || "Unknown"}</div>
                  <div className="ord-item">{o.item_name}</div>
                </div>
                <span className={`ord-pill ${o.status}`}>{o.status}</span>
              </div>

              {/* DETAILS */}
              <div className="ord-details">
                <span className="ord-detail-chip">📦 Qty: {o.quantity}</span>
                {o.requested_at && (
                  <span className="ord-detail-chip">🗓 {o.requested_at}</span>
                )}
              </div>

              {/* PENDING ACTIONS */}
              {o.status === "pending" && (
                <div className="ord-actions">
                  <button className="ord-btn-approve" onClick={() => handleUpdate(o.id, "approved")}>
                    ✔ Approve
                  </button>
                  <button className="ord-btn-reject" onClick={() => handleUpdate(o.id, "rejected")}>
                    ✖ Reject
                  </button>
                </div>
              )}

              {/* APPROVED → COMPLETE */}
              {o.status === "approved" && (
                <button className="ord-btn-complete" onClick={() => handleUpdate(o.id, "completed")}>
                  ✅ Mark Completed
                </button>
              )}

            </div>
          ))}
        </div>
      )}

    </div>
  );
}
